/**
 * Módulo inventario: reconteo, comparación y ticket de diferencias.
 */

function escapeHtml(str) {
	return String(str || '')
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;');
}

function getCurrentUserName(win) {
	const ej = win.posknEjecutorFacturacion || {};
	return ej.nombre || '';
}

function getInventarioSourceData(win) {
	const inv = win.inventarioProductosData;
	const prod = win.productosData;
	if (Array.isArray(inv) && inv.length > 0) return inv;
	if (Array.isArray(prod) && prod.length > 0) return prod;
	return [];
}

function initInventarioAdminEvents(win, $) {
	if (win._posknInventarioAdminBound) return;
	win._posknInventarioAdminBound = true;

	$(document).on('input', '#inventario-buscar', () => {
		if (win.inventarioListaProductos) win.renderInventarioTabla(win.inventarioListaProductos);
	});
	$(document).on('change', '#inventario-categoria', () => {
		if (win.inventarioListaProductos) win.renderInventarioTabla(win.inventarioListaProductos);
	});
	$(document).on('click', '#btn-compare-inventario', () => win.compararInventario());
	$(document).on('click', '#btn-imprimir-inventario-ticket', () => win.imprimirTicketInventario());
}

export function attachInventarioAdminGlobals(win, $) {
	initInventarioAdminEvents(win, $);

	win.renderInventarioTabla = function renderInventarioTabla(lista) {
		const filtro = ($('#inventario-buscar').val() || '').toLowerCase().trim();
		const catSel = $('#inventario-categoria').val() || '';
		let filtrados = lista;
		if (catSel) {
			filtrados = filtrados.filter((p) => p.categoria === catSel);
		}
		if (filtro) {
			filtrados = filtrados.filter(
				(p) =>
					(p.name && p.name.toLowerCase().includes(filtro)) ||
					(p.sku && p.sku.toLowerCase().includes(filtro)),
			);
		}
		let html = '';
		filtrados.forEach((p) => {
			html += `<tr data-id="${p.id}" data-stock="${p.stock != null ? p.stock : ''}" data-managing="${p.managing_stock ? '1' : '0'}">`;
			html += `<td>${escapeHtml(p.name)}</td>`;
			html += `<td>${p.sku ? escapeHtml(p.sku) : '—'}</td>`;
			html += `<td><input type="number" min="0" step="1" class="inv-input" placeholder="0" data-id="${p.id}"></td>`;
			html += '<td class="inv-col-diff inv-diff-text" data-diff></td></tr>';
		});
		$('#inventario-tbody').html(
			html || '<tr><td colspan="4">No hay productos para mostrar.</td></tr>',
		);
	};

	win.cargarInventario = function cargarInventario() {
		const lista = [];
		const categorias = [];
		const datos = getInventarioSourceData(win);

		datos.forEach((cat) => {
			const catName = cat.category_name || 'Sin categorizar';
			if (!categorias.includes(catName)) categorias.push(catName);
			if (!cat.products || !Array.isArray(cat.products)) return;

			cat.products.forEach((p) => {
				if (p.type === 'variable' && p.variations && p.variations.length) {
					p.variations.forEach((v) => {
						lista.push({
							id: v.id,
							name: `${p.name} (${v.attributes ? Object.values(v.attributes).join(', ') : ''})`,
							sku: v.sku || '',
							stock: parseInt(v.stock, 10),
							managing_stock: true,
							categoria: catName,
						});
					});
				} else {
					const stockVal = p.managing_stock ? parseInt(p.stock, 10) || 0 : null;
					lista.push({
						id: p.id,
						name: p.name,
						sku: p.sku || '',
						stock: stockVal,
						managing_stock: !!p.managing_stock,
						categoria: catName,
					});
				}
			});
		});

		win.inventarioListaProductos = lista;

		let optsCat = '<option value="">Todas las categorías</option>';
		categorias.forEach((c) => {
			optsCat += `<option value="${escapeHtml(c)}">${escapeHtml(c)}</option>`;
		});
		$('#inventario-categoria').html(optsCat);
		$('#inventario-resumen').hide().empty();
		$('#btn-compare-inventario').prop('disabled', false);
		$('#inventario-buscar').prop('readonly', false);
		$('#btn-imprimir-inventario-ticket').hide();
		win.renderInventarioTabla(lista);
	};

	win.compararInventario = function compararInventario() {
		const lista = win.inventarioListaProductos;
		if (!lista || !lista.length) return;

		let totalFalta = 0;
		let totalSobra = 0;
		let filasConFalta = 0;
		let filasConSobra = 0;

		$('#inventario-tbody tr').each(function eachRow() {
			const $tr = $(this);
			if ($tr.find('td[colspan]').length) return;
			const stockActual = parseInt($tr.data('stock'), 10);
			const managing = $tr.data('managing') === 1;
			const reportado = parseInt($tr.find('.inv-input').val(), 10) || 0;
			$tr.removeClass('inv-diff-falta inv-diff-sobra inv-diff-igual');
			const $diff = $tr.find('[data-diff]');
			if (!managing || stockActual === undefined || Number.isNaN(stockActual)) {
				$diff.text('N/A').css('color', '');
				return;
			}
			const diff = reportado - stockActual;
			if (diff === 0) {
				$tr.addClass('inv-diff-igual');
				$diff.text('✓ Igual').css('color', '#2e7d32');
			} else if (diff < 0) {
				$tr.addClass('inv-diff-falta');
				$diff.text(`Falta ${Math.abs(diff)}`).css('color', '#c62828');
				totalFalta += Math.abs(diff);
				filasConFalta += 1;
			} else {
				$tr.addClass('inv-diff-sobra');
				$diff.text(`Sobra ${diff}`).css('color', '#546e7a');
				totalSobra += diff;
				filasConSobra += 1;
			}
		});

		let resumen = '<div class="resumen-total">';
		if (filasConFalta > 0 || totalFalta > 0) {
			resumen += `<p style="color:#c62828;"><strong>Total unidades que faltan:</strong> ${totalFalta} (en ${filasConFalta} producto(s))</p>`;
		}
		if (filasConSobra > 0 || totalSobra > 0) {
			resumen += `<p style="color:#546e7a;"><strong>Total unidades que sobran:</strong> ${totalSobra} (en ${filasConSobra} producto(s))</p>`;
		}
		if (filasConFalta === 0 && filasConSobra === 0) {
			resumen += '<p style="color:#2e7d32;"><strong>Inventario cuadra con lo reportado.</strong></p>';
		}
		resumen += '</div>';
		$('#inventario-resumen').html(resumen).show();
		$('#inventario-tbody .inv-input').prop('readonly', true).addClass('inv-input-blocked');
		$('#inventario-buscar').prop('readonly', true);
		$('#btn-compare-inventario').prop('disabled', true);
		$('#btn-imprimir-inventario-ticket').show();
		win.setTimeout(() => win.imprimirTicketInventario(), 500);
	};

	win.imprimirTicketInventario = function imprimirTicketInventario() {
		const filas = [];
		$('#inventario-tbody tr').each(function eachRow() {
			const $tr = $(this);
			if ($tr.find('td[colspan]').length) return;
			filas.push({
				nombre: $tr.find('td:eq(0)').text().trim(),
				sku: $tr.find('td:eq(1)').text().trim().replace('—', ''),
				reportado: $tr.find('.inv-input').val() || '0',
				diferencia: $tr.find('[data-diff]').text().trim(),
			});
		});

		const resumenTexto = $('#inventario-resumen').text().replace(/\s+/g, ' ').trim();
		const ahora = new Date();
		const fechaStr = `${ahora.toLocaleDateString('es-ES')} ${ahora.toLocaleTimeString('es-ES')}`;
		const usuario = getCurrentUserName(win);

		let body = '<div class="ticket">';
		body += '<div class="ticket-header"><strong>INVENTARIO</strong></div>';
		body += `<div class="ticket-fecha">${fechaStr}</div>`;
		body += `<div class="ticket-fecha">${escapeHtml(usuario)}</div>`;
		body += '<div class="ticket-linea">------------------------------</div>';
		body += '<div class="ticket-seccion"><strong>Producto | Reportado | Dif.</strong></div>';
		body += '<div class="ticket-linea">------------------------------</div>';
		filas.forEach((r) => {
			body += `<div class="ticket-fila">${escapeHtml((r.nombre || '').substring(0, 28))}</div>`;
			body += `<div class="ticket-fila">  Reportado: ${escapeHtml(r.reportado)} | ${escapeHtml(r.diferencia)}</div>`;
		});
		body += '<div class="ticket-linea">------------------------------</div>';
		if (resumenTexto) body += `<div class="ticket-resumen">${escapeHtml(resumenTexto)}</div>`;
		body += '<div class="ticket-linea">------------------------------</div>';
		body += '<div class="ticket-footer">Sistema POS - Inventario</div></div>';

		const estilos =
			'body{margin:8px;padding:0;font-family:"Courier New",monospace;font-size:12px;line-height:1.3;color:#000;font-weight:bold;}' +
			' .ticket{max-width:300px;} .ticket-header{text-align:center;font-size:16px;font-weight:900;}' +
			' .ticket-seccion{text-align:center;font-size:13px;font-weight:900;}' +
			' .ticket-fecha,.ticket-footer{text-align:center;font-size:10px;}' +
			' .ticket-linea{text-align:center;} .ticket-fila{margin:2px 0;}' +
			' .ticket-resumen{margin:8px 0;white-space:normal;font-weight:bold;}' +
			' @media print{body{-webkit-print-color-adjust:exact;print-color-adjust:exact;}}';

		const printWin = win.open('', '_blank', 'width=320,height=500');
		if (!printWin) {
			win.mostrarNotificacion('Permite ventanas emergentes para imprimir el ticket.', 'error');
			return;
		}
		printWin.document.write(
			`<!DOCTYPE html><html><head><meta charset="UTF-8"><style>${estilos}</style><title>Ticket Inventario</title></head><body>${body}</body></html>`,
		);
		printWin.document.close();
		win.setTimeout(() => {
			try {
				printWin.print();
				win.setTimeout(() => printWin.close(), 1500);
			} catch (e) {
				win.mostrarNotificacion('Error al imprimir', 'error');
			}
		}, 400);
		win.mostrarNotificacion('Ticket enviado a impresión', 'success');
	};
}
